// UsageHistoryLanding.tsx
import React from "react";
import RecentMessage from "../recentMessage/recentMessage";
import { useParams } from "react-router-dom";
import WorkflowCard from "../workflow/workflow";
import { useTemplateWorkflow } from "@features/ux/components/templates/hooks";

const UsageHistoryLanding = () => {
  const { id } = useParams();
  const { data: templateWorkflowData } = useTemplateWorkflow(id);
  return (
    <div>
      <WorkflowCard workflows={templateWorkflowData?.results || []} />
      <div className="mt-4">
        <RecentMessage messages={templateWorkflowData?.recentMessages || []} />
      </div>
    </div>
  );
};

export default UsageHistoryLanding;
